import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import DynamicRendering from '@adv-mt/mt-perf-dynamic-rendering'
import SharedCorporateFooter, {sharedCorporateFooterHeights} from '@adv-mt/mt-shared-corporate-footer'
import MotorSharedTopbar from '@adv-mt/mt-shared-topbar'

import {LAYOUT_BASIC_FULL_HEIGHT_BASE_CLASS_NAME} from '../../settings.js'
import LayoutBasicContainer from '../Container/index.js'

const LayoutBasicFullHeight = ({
  children,
  footerProps,
  isFooterless = false,
  isHeaderless = false,
  linkFactory,
  topbarProps = {}
}) => {
  const {
    domain,
    browser: {deviceType}
  } = useContext(Context)
  const config = domain.get('config')

  const appName = config.get('APP_NAME')

  const showFooter = !isFooterless
  const showHeader = !isHeaderless

  const footerHeight = sharedCorporateFooterHeights[appName][deviceType]

  const className = cx(LAYOUT_BASIC_FULL_HEIGHT_BASE_CLASS_NAME, {
    [`${LAYOUT_BASIC_FULL_HEIGHT_BASE_CLASS_NAME}--headerless`]: !showHeader
  })

  return (
    <div className={className}>
      {showHeader && <MotorSharedTopbar linkFactory={linkFactory} {...topbarProps} />}
      <LayoutBasicContainer isFullHeight>{children}</LayoutBasicContainer>
      {showFooter && (
        <DynamicRendering height={footerHeight}>
          <SharedCorporateFooter linkFactory={linkFactory} {...footerProps} />
        </DynamicRendering>
      )}
    </div>
  )
}

LayoutBasicFullHeight.displayName = 'LayoutBasicFullHeight'
LayoutBasicFullHeight.propTypes = {
  children: PropTypes.element,
  footerProps: PropTypes.shape({
    linkFactory: PropTypes.func.isRequired
  }),
  isFooterless: PropTypes.bool,
  isHeaderless: PropTypes.bool,
  topbarProps: PropTypes.shape({
    linkFactory: PropTypes.func.isRequired
  }),
  linkFactory: PropTypes.func
}

export default LayoutBasicFullHeight
